import React, { useState, useEffect } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { Box, Flex, VStack, Button, useColorModeValue, useColorMode, IconButton } from '@chakra-ui/react';
import { useClerk, useUser } from '@clerk/clerk-react';
import Walter from './Walter';
import UserOutputs from './UserOutputs';
import FileUploader from './FileUploader';
import ResourceListGenerator from './ResourceListGenerator';


const Layout = () => {
  const { signOut } = useClerk();
  const { user } = useUser();
  const [view, setView] = useState('walter');
  const [isAdmin, setIsAdmin] = useState(false);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const [socket, setSocket] = useState(null);
  const [isSocketConnected, setIsSocketConnected] = useState(false);

  const sidebarColor = useColorModeValue('brand.700', 'brand.200');
  const headerColor = useColorModeValue('brand.600', 'brand.300');

  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    if (user) {
      fetch(`${backendUrl}/is-admin/${user.id}`)
        .then(response => response.json())
        .then(data => setIsAdmin(data.is_admin))
        .catch(error => console.error('Error fetching admin status:', error));
    }
  }, [user, backendUrl]);

  useEffect(() => {
    console.log(`WebSocket URL: ${process.env.REACT_APP_WS_URL}/${user.id}`);
    const connectWebSocket = () => {
      if (!user) return; // Only connect if the user is logged in

      const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/${user.id}`);

      //let pingInterval;

      ws.onopen = () => {
        console.log('WebSocket Connected', ws.url);
        setIsSocketConnected(true);

        // Send a ping every 30 seconds
       // pingInterval = setInterval(() => {
        //  ws.send(JSON.stringify({ type: 'ping' }));
       // }, 30000);
      };

      ws.onclose = (event) => {
        console.log(`WebSocket Disconnected from ${ws.url}, Code: ${event.code}, Reason: ${event.reason}`);
        setIsSocketConnected(false);
        //clearInterval(pingInterval);
        // Attempt to reconnect every 5 seconds
        setTimeout(connectWebSocket, 5000);
      };

      ws.onerror = (error) => {
        console.error('WebSocket Error occurred on', ws.url, ':', error.message);
        ws.close();
      };

      setSocket(ws);

      return () => {
        ws.close();
        //clearInterval(pingInterval);
      };
    };

    if (user) {
      connectWebSocket();
    }
  }, [user]);

  const handleLogout = async () => {
    // Clear local storage items related to the session

    const sessionId = localStorage.getItem('sessionId');

    // Call the logout endpoint with the session ID
    if (sessionId) {
      try {
        await fetch(`${backendUrl}/logout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id: sessionId }),
        });
        console.log('Session cleared successfully');
      } catch (error) {
        console.error('Failed to clear the session:', error);
      }
    }

    localStorage.removeItem('task');
    localStorage.removeItem('researchReport');
    localStorage.removeItem('agentOutput');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('selectedVersion');
    localStorage.removeItem('availableVersions');
    localStorage.removeItem('userId');
    if (socket) socket.close();
    await signOut();
  };

  return (
    <Flex direction="column" height="100vh">
      <Box bg={headerColor} px="4" py="2" color="white" display="flex" alignItems="center">
        <Button colorScheme="teal" onClick={handleLogout}>Logout</Button>
        <IconButton icon={colorMode === 'dark' ? <FaSun /> : <FaMoon />} isRound={true} size="md" alignSelf="flex-end" onClick={toggleColorMode} variant="ghost" />
      </Box>
      <Flex flex="1" overflow="hidden">
        <VStack bg={sidebarColor} p="4" color="white" align="stretch" w="20%" spacing="4">
          <Button onClick={() => setView('walter')}>Walter</Button>
          <Button onClick={() => setView('outputs')}>Outputs</Button> 
          {/* <Button onClick={() => setView('upload')}>Documents</Button> */}
          {isAdmin && <Button onClick={() => setView('resourceList')}>Resource Generator</Button>}
        </VStack>
        <Box flex="1" p="4" overflowY="auto">
          {view === 'walter' && <Walter ws={socket} isSocketConnected={isSocketConnected} user={user} />}
          {view === 'outputs' && <UserOutputs userId={user?.id} />}
          {view === 'upload' && <FileUploader userId={user?.id} />}
          {view === 'resourceList' && isAdmin && <ResourceListGenerator userId={user?.id} />}
        </Box>
      </Flex>
    </Flex>
  );
};

export default Layout;
